import { BOGGLE_PURPLE_TILE_KIND } from '../kinds'
import type { BoggleSpecialTileDefinition } from '../tileTypes'

export const purpleTileDefinition: BoggleSpecialTileDefinition = {
  description: 'Word score is doubled if all tiles are purple',
  kind: BOGGLE_PURPLE_TILE_KIND,
  label: 'Purple',
  previewFill: '#61336f',
  previewTextColor: '#f7e8ff',
  scoreBonusPerPathPosition: 0,
  timeBonusPerWordMs: 0,
  tileShape: 'pentagon',
}
